import React, {useState} from 'react';
import moment from 'jalali-moment';

import {useHttpClient} from '../../../../common/hook/http';
import FormElement from '../../../../common/component/FormElement/FormElement';
import {useFrom} from '../../../../common/hook/form';
import {useToast} from '../../../../common/hook/toast';
import {validatorNotEmpty} from '../../../../common/util/validators';
import showValidators from '../../../../common/util/show-validators';

import GlobalConst from '../../../../common/global-const';
import currency from '../../../../common/util/currency';

import {Row, Col, Form, Button, Spinner, Accordion, Table} from 'react-bootstrap';

import * as IconFi from 'react-icons/fi';

const RealEstateRequestForm = props => {
    const {callAPI} = useHttpClient()
    const {callToast} = useToast()

    const data = props.item
    const step = props.step

    // ----------------------------------------------------------------------------------------------------- form submit

    const [spinnerShow, setSpinnerShow] = useState(false)

    const [formState, inputHandler] = useFrom({
        formEntertainTicketOrderEntertainment_place_id: {
            // شرط برای زمانی است که پرداخت از حساب کاربری درخواست شود و authority مقدار خواهد داشت
            value: data.entertainmentPlace.authority ? data.entertainmentPlace.entertainment_place_id : data.entertainmentPlace.id,
            isValid: true
        },
        formEntertainTicketOrderReserve_date: {
            value: data.entertainmentPlace.authority ? data.entertainmentPlace.reserve_date : '',
            isValid: !!data.entertainmentPlace.authority
        },
        formEntertainTicketOrderReserve_time: {
            value: data.entertainmentPlace.authority ? data.entertainmentPlace.reserve_time : '',
            isValid: !!data.entertainmentPlace.authority
        },
        formEntertainTicketOrderType: {
            value: data.entertainmentPlace.authority ? data.entertainmentPlace.type : '',
            isValid: !!data.entertainmentPlace.authority
        },
        formEntertainTicketOrderReserve_count: {
            // تونل باد همیشه تعداد 1 است پس valid هم هست
            value: data.entertainmentPlace.authority ? data.entertainmentPlace.reserve_count : data.entertainmentPlace.id === '1' ? '1' : '',
            isValid: data.entertainmentPlace.authority ? true : data.entertainmentPlace.id === '1'
        }
    }, !!data.entertainmentPlace.authority)

    const stepHandler = event => {
        event.preventDefault()

        if (event.type === 'submit') {

            if (formState.isValid) props.onStepChange(event)
            else showValidators(formState.inputs)

        } else {

            props.onStepChange(event)

        }

    };

    const formSubmitHandler = async event => {
        event.preventDefault();

        setSpinnerShow(true);

        const values = {}

        for (const item in formState.inputs) {
            let tempKey = item.split('formEntertainTicketOrder')[1];
            tempKey = tempKey.charAt(0).toLowerCase() + tempKey.slice(1);
            values[tempKey] = formState.inputs[item].value
        }

        try {
            const responseData = await callAPI(
                'entertainment/register',
                'POST',
                JSON.stringify(values)
            )

            // console.log(responseData)

            if (responseData.message) {

                setSpinnerShow(false);
                callToast('secondary', null, null, responseData.message);

            } else {

                const elementForm = document.createElement('form');
                elementForm.action = GlobalConst.ipg;
                elementForm.method = 'post';

                const elementInput = document.createElement('input');
                elementInput.type = 'text';
                elementInput.name = 'token';
                elementInput.value = responseData.result.authority;

                const elementInput2 = document.createElement('input');
                elementInput.type = 'text';
                elementInput.name = 'language';
                elementInput.value = 'fa';

                elementForm.appendChild(elementInput)
                elementForm.appendChild(elementInput2)

                document.body.appendChild(elementForm)

                elementForm.submit()

            }

        } catch (err) {
            setSpinnerShow(false);
            callToast('secondary', null, null, err.message);
        }

    };

    // -----------------------------------------------------------------------------------------------------------------

    const renderDateLabel = item => {
        return (
            <span className="d-inline-block w-100 p-3 bg-elevate-6 border-top border-white-5" role="button">
                <span className="d-flex flex-column">
                    <span className="text-white text-opacity-60">{GlobalConst.days[Number(moment(item, 'jYYYY/jMM/jDD').format('d'))].fa}</span>
                    <span className="fs-5 lh-1 ls-1 mb-1">{item}</span>
                </span>
            </span>
        )
    }

    const renderTimeLabel = item => {
        return (
            <span className="d-inline-block w-100 p-3 bg-elevate-6 border-top border-white-5" role="button">
                <span className="d-flex flex-column">
                    <span className="text-white text-opacity-60">ظرفیت {item.freeCount} نفر</span>
                    <span className="fs-5 lh-1 ls-1 mb-1">{item.start_time} <span className="fs-6 ls-normal">تا</span> {item.end_time}</span>
                </span>
            </span>
        )
    }

    const renderTypeLabel = item => {
        return (
            <span className="d-inline-flex w-100 p-3 bg-elevate-6 border-top border-white-5" role="button">
                <span className="d-flex flex-column mt-auto">
                    {
                        Number(item.discount) ? (
                            <span className="fw-bold text-primary"><span className="me-1">{item.discount}%</span>تخفیف</span>
                        ) : (
                            <></>
                        )
                    }
                    <span className="fs-5 text-white text-opacity-60 d-flex align-items-baseline">
                        {currency(Number(item.discount) ? Number(item.price) - (item.price * Number(item.discount) / 100) : item.price)} {GlobalConst.currency}
                    </span>
                    <span className="fs-5 lh-sm mb-1">{item.label}</span>
                    {
                        item.booked_seconds && item.person ? (
                            <span className="fs-6 mb-1 lh-sm">{item.booked_seconds} دقیقه ({item.person} نفر)</span>
                        ) : (
                            <></>
                        )
                    }
                </span>
            </span>
        )
    }

    // -----------------------------------------------------------------------------------------------------------------

    const renderDiscount = () => {

        let item = data.priceList.find(({value}) => value === formState.inputs.formEntertainTicketOrderType.value);

        // if (!item) return <></>
        if (!item) return 0

        let discountItem = Number(item.discount) ? item.price * item.discount / 100 : 0;

        return discountItem * formState.inputs.formEntertainTicketOrderReserve_count.value

    }

    const renderTax = () => {

        let item = data.priceList.find(({value}) => value === formState.inputs.formEntertainTicketOrderType.value);

        // if (!item) return <></>
        if (!item) return 0

        return ((item.price * formState.inputs.formEntertainTicketOrderReserve_count.value - renderDiscount()) * data.tax) / 100

    }

    const renderTotal = () => {

        let item = data.priceList.find(({value}) => value === formState.inputs.formEntertainTicketOrderType.value);

        if (!item) return <></>

        return item.price * formState.inputs.formEntertainTicketOrderReserve_count.value - renderDiscount() + renderTax()

    }

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <>
            {
                step === 2 && (
                    <Form id="formEntertainTicketOrderStep2" onSubmit={stepHandler} autoComplete="off">
                        <Row>
                            <Col xs={12} className="pb-4 pb-lg-5">
                                <p className="fs-3 mb-0 text-primary text-center">{data.entertainmentPlace.name}</p>
                            </Col>
                            <Col xs={12}>
                                <Accordion activeKey={['0', formState.inputs.formEntertainTicketOrderReserve_date.value !== '' && '1', formState.inputs.formEntertainTicketOrderReserve_date.value !== '' && '2', formState.inputs.formEntertainTicketOrderType.value !== '' && '3']} alwaysOpen flush>
                                    <Accordion.Item eventKey="0" className="bg-transparent">
                                        <Accordion.Header>تاریخ را انتخاب نمایید</Accordion.Header>
                                        <Accordion.Body>
                                            <FormElement component="RADIO_GROUP" id="formEntertainTicketOrderReserve_date" name="eserve_date" labelGroup=""
                                                         radioGroup={Object.keys(data.arrayTime).map(item => {return {label: renderDateLabel(item), value: item}})}
                                                         validators={[validatorNotEmpty()]} inline textInvalid="تاریخ را انتخاب نمایید" onInput={inputHandler}/>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1" className="bg-transparent">
                                        <Accordion.Header><span>ساعت را انتخاب نمایید</span></Accordion.Header>
                                        <Accordion.Body>
                                            {
                                                formState.inputs.formEntertainTicketOrderReserve_date.value !== '' && (
                                                    <FormElement component="RADIO_GROUP" id="formEntertainTicketOrderReserve_time" name="reserve_time" labelGroup=""
                                                                 radioGroup={data.arrayTime[formState.inputs.formEntertainTicketOrderReserve_date.value].map(item => {return {label: renderTimeLabel(item), value: item.value}})}
                                                                 validators={[validatorNotEmpty()]} inline textInvalid="ساعت را انتخاب نمایید" onInput={inputHandler}/>
                                                )
                                            }
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="2" className="bg-transparent">
                                        <Accordion.Header><span>نوع بلیط را انتخاب نمایید</span></Accordion.Header>
                                        <Accordion.Body className="type">
                                            <FormElement component="RADIO_GROUP" id="formEntertainTicketOrderType" name="reserve_type" labelGroup="" radioGroup={data.priceList.map(item => {return {label: renderTypeLabel(item), value: item.value}})}
                                                         validators={[validatorNotEmpty()]} inline textInvalid="نوع را انتخاب نمایید" onInput={inputHandler}/>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {
                                        data.entertainmentPlace.id === '4' ? (
                                            <Accordion.Item eventKey="3" className="bg-transparent">
                                                <Accordion.Header><span>تعداد را وارد نمایید</span></Accordion.Header>
                                                <Accordion.Body>
                                                    <Col sm={6} lg={4}>
                                                        <FormElement component="INPUT" id="formEntertainTicketOrderReserve_count" name="reserve_count" className="ltr" label="" validators={[validatorNotEmpty()]}
                                                                     textInvalid="تعداد را وارد نمایید" maxLength="2" append={<span className="px-3">{formState.inputs.formEntertainTicketOrderType.value === 'vip' ? `کابین` : `نفر`}</span>} digit inputMode="numeric" onInput={inputHandler}/>
                                                    </Col>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        ) : (
                                            <></>
                                        )
                                    }
                                </Accordion>
                            </Col>
                            <Col xs={12} className="py-2 d-grid d-md-flex justify-content-md-between page-footer" style={{gridTemplateColumns: '1fr 1fr'}}>
                                <Button variant="link" className="my-1 my-md-0 me-3 text-decoration-none ps-0" onClick={stepHandler}><IconFi.FiArrowRight size={24} className="sw-1 me-2"/>بازگشت</Button>
                                <Button type="submit" className="my-1 my-md-0">مرحله بعد<IconFi.FiArrowLeft size={24} className="sw-1 ms-2"/></Button>
                            </Col>
                        </Row>
                    </Form>
                )
            }
            {
                step === 3 && (
                    <Form id="formEntertainTicketOrderStep3" onSubmit={formSubmitHandler} autoComplete="off">
                        <Row>
                            <Col xs={12}>
                                <Table bordered responsive>
                                    <thead className="text-white text-opacity-60">
                                    <tr>
                                        <th>عنوان</th>
                                        <th>تعداد</th>
                                        <th>قیمت واحد</th>
                                        <th>قیمت کل</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>
                                            بلیط {data.entertainmentPlace.name} ({data.priceList.find(({value}) => value === formState.inputs.formEntertainTicketOrderType.value)?.label})
                                            <br/>
                                            {formState.inputs.formEntertainTicketOrderReserve_date.value}<span className="ms-2">ساعت </span>{formState.inputs.formEntertainTicketOrderReserve_time.value} تا {data.arrayTime[formState.inputs.formEntertainTicketOrderReserve_date.value].find(({start_time}) => start_time === formState.inputs.formEntertainTicketOrderReserve_time.value).end_time}
                                        </td>
                                        <td>{formState.inputs.formEntertainTicketOrderReserve_count.value}</td>
                                        <td>{currency(data.priceList.find(({value}) => value === formState.inputs.formEntertainTicketOrderType.value)?.price)}</td>
                                        <td>{currency(data.priceList.find(({value}) => value === formState.inputs.formEntertainTicketOrderType.value)?.price * formState.inputs.formEntertainTicketOrderReserve_count.value)}</td>
                                    </tr>
                                    {
                                        Number(data.priceList.find(({value}) => value === formState.inputs.formEntertainTicketOrderType.value)?.discount) ? (
                                            <tr>
                                                <td colSpan={3}>تخفیف</td>
                                                <td>{currency(renderDiscount())}</td>
                                            </tr>
                                        ) : (
                                            <></>
                                        )
                                    }
                                    <tr>
                                        <td colSpan={3}>مالیات {data.tax} درصد</td>
                                        <td>{currency(renderTax())}</td>
                                    </tr>
                                    <tr className="fs-5 bg-primary bg-opacity-25">
                                        <td colSpan={3}>مبلغ قابل پرداخت</td>
                                        <td>{currency(renderTotal())}</td>
                                    </tr>
                                    </tbody>
                                </Table>
                                <p className="text-white text-opacity-60 fs-8">راهنما: کلیه قیمت ها بر حسب {GlobalConst.currency} می باشد.</p>
                            </Col>
                            <Col xs={12} className="py-2 d-grid d-md-flex justify-content-md-between page-footer" style={{gridTemplateColumns: '1fr 1fr'}}>
                                <Button variant="link" className="my-1 my-md-0 me-3 text-decoration-none ps-0" onClick={stepHandler}><IconFi.FiArrowRight size={24} className="sw-1 me-2"/>بازگشت</Button>
                                <Button type="submit" className="my-1 my-md-0 px-5 btn-loading" disabled={spinnerShow}>
                                    <Spinner as="i" animation="border" size="sm" className={spinnerShow && 'opacity-100'}/>
                                    <span>پرداخت</span>
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                )
            }
        </>
    )
}

export default RealEstateRequestForm;